<template>
  <div class="pdf-viewer-wrapper">
    <VPdfViewer
      v-bind="$attrs"
      :src="props.src"
      :locale="viewerLocale"
      :localization="PDF_VIEWER_LOCALIZATIONS"
      @load="onLoad"
      @error="onError"
    />
  </div>
</template>

<script setup lang="ts">
/* global VITE_PDF_VIEWER_API_KEY */
import {
  useLicense,
  VPdfViewer
} from '@vue-pdf-viewer/viewer'
import {computed} from "vue";
import { useI18n } from 'vue-i18n'
import {PDF_VIEWER_LOCALIZATIONS} from "@/config/pdfViewerLocalization";

interface Props {
  src: string;
  height?: string;
}
defineOptions({ inheritAttrs: false, })
const props = defineProps<Props>()

const { locale } = useI18n()
const viewerLocale = computed(() => locale.value === 'de' ? 'de_DE' : 'en_US' )

const emit = defineEmits<{
  (e: 'load'): void;
  (e: 'error', error: Error): void;
}>();

useLicense(import.meta.env.VITE_PDF_VIEWER_API_KEY)

function onLoad() {
  emit('load');
}

function onError(error: unknown) {
  const normalizedError =
    error instanceof Error
      ? error
      : new Error('Failed to load PDF')

  console.error('PDF viewer error:', error)
  emit('error', normalizedError)

}
</script>

<style lang="scss" scoped>
.pdf-viewer-wrapper {
  width: 100%;
  height: 100%;
  min-height: 0;
  overflow: hidden;
}
</style>
